/* ═══════════════════════════════════════════════════════════════
   Header add-ons:
   1) Brief-modal skip guard for whitelisted products
      (AI Video Starter Guide PDF etc. — no brief popup on those).
   2) Inject a "Case Study" button next to the Start-your-project
      CTA in the header's navigation-buttons block.
   ═══════════════════════════════════════════════════════════════ */
(function () {

  /* ─── 1. Brief-modal skip guard ─── */
  var SKIP = [
    'ai-video-starter-guide',
    'ai-starter-kit',
    'ai-starter-pack',
    'starter-kit',
    'starter-pack',
    'digital-starter-kit'
  ];

  function onSkipPage() {
    var p = (window.location.pathname || '').toLowerCase();
    for (var i = 0; i < SKIP.length; i++) {
      if (p.indexOf('/products/' + SKIP[i]) !== -1) return true;
    }
    return false;
  }

  if (onSkipPage()) {
    function isAddClick(target) {
      if (!target || !target.closest) return false;
      var btn = target.closest('button, [role="button"], input[type="submit"], a');
      if (!btn) return false;
      if (btn.closest('#po-brief-modal')) return false;
      if (btn.name === 'add' || btn.getAttribute('name') === 'add') return true;
      if (btn.matches && btn.matches('.product-form__submit, .add-to-cart-btn, .buy-button, [data-add-to-cart], [data-cart-add-button], .shopify-payment-button__button, [data-shopify="dynamic-checkout-cart-button"]')) return true;
      var f = btn.closest('form');
      if (f && /\/cart\/add(?:\.js)?(?:$|\?)/.test(f.action || '') && (btn.type === 'submit' || btn.getAttribute('type') === 'submit')) return true;
      var label = (btn.textContent || '').trim().toLowerCase();
      if (f && /\/cart\/add/.test(f.action || '') && /(add to cart|add to bag|buy now)/i.test(label)) return true;
      return false;
    }

    window.addEventListener('click', function (e) {
      if (!isAddClick(e.target)) return;
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    }, true);

    window.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.action || !/\/cart\/add/.test(f.action)) return;
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    }, true);

    function nukeModal() {
      var m = document.getElementById('po-brief-modal');
      if (m && m.parentNode) m.parentNode.removeChild(m);
      document.documentElement.classList.remove('pobm-lock');
      document.body && document.body.classList.remove('pobm-lock');
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', nukeModal);
    } else {
      nukeModal();
    }
    new MutationObserver(nukeModal).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ─── 2. Inject "Case Study" button before the CTA ─── */
  var CS_INJECTED = 'data-cs-injected';

  function injectCaseStudyBtn() {
    var wrappers = document.querySelectorAll(
      '#shopify-section-header .navigation-buttons__wrapper,' +
      '.shopify-section-header .navigation-buttons__wrapper,' +
      '.navigation-buttons--wide .navigation-buttons__wrapper'
    );
    if (!wrappers.length) return false;
    var done = false;
    wrappers.forEach(function (wrapper) {
      if (wrapper.getAttribute(CS_INJECTED) === '1') return;
      var cta = wrapper.querySelector('.block__button');
      if (!cta) return;
      wrapper.setAttribute(CS_INJECTED, '1');
      /* Mirror the theme CTA's exact class set so font/size/hover match */
      var csBlock = document.createElement('div');
      csBlock.className = 'block__button buttons-zoom header-case-study-btn';
      csBlock.innerHTML =
        '<a href="/pages/case-studies" class="solid-button icon-button button--contrast header-case-study-btn__link">' +
        '<span class="icon-button__title">Case Studies</span>' +
        '</a>';
      wrapper.insertBefore(csBlock, cta);
      done = true;
    });
    return done;
  }

  function bootCsBtn() {
    if (injectCaseStudyBtn()) return;
    new MutationObserver(function () { injectCaseStudyBtn(); })
      .observe(document.documentElement, { childList: true, subtree: true });
    [200, 600, 1500, 3000].forEach(function (ms) { setTimeout(injectCaseStudyBtn, ms); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCsBtn);
  } else {
    bootCsBtn();
  }
})();
